import { GET, POST, PUT, DELETE } from "../../api";

export const LoginPost = async (data) => {
  return await POST(`/common/auth/admin-login`, data);
};
